import { Fragment, useMemo, useState } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { useNavigate } from "react-router";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";
import { getProductColumns } from "../../Components/product/Product.columns";
import { useAdmin } from "../../../context/AdminContext";

export const ProductList = () => {
  const navigate = useNavigate();
  const { getData, patchData, invalidateQuery } = useDataFetch();
  const { admin } = useAdmin();
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });

  const { data, isLoading } = getData(
    ["product", pagination],
    "/product",
    { enabled: true },
    {
      page: pagination.pageIndex + 1,
      limit: pagination.pageSize,
    }
  );

  const { mutateAsync: toggleProductStatus } = patchData(
    "/product/toggle-status",
    {},
    {
      onSuccess: () => {
        invalidateQuery(["product"]);
      },
    }
  );

  const handleToggleStatus = (product) => {
    const isActive = product.status;
    const actionText = isActive ? "Inactivar" : "Activar";

    Swal.fire({
      title: `¿Quieres ${actionText} este producto?`,
      text: `Producto: ${product.title}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isActive ? "#d33" : "#3085d6",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Sí, ${actionText}`,
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await toggleProductStatus({ id: product.id });
        Swal.fire({
          title: "¡Hecho!",
          text: `El producto ha sido ${isActive ? "inactivado" : "activado"} correctamente.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const columnHelper = createColumnHelper();
  const columns = useMemo(
    () => getProductColumns(columnHelper, navigate, handleToggleStatus, admin?.role),
    [navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs parent="Tienda" title="Productos" mainTitle="Productos" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <div className="d-flex justify-content-end px-3 pt-3">
                <Btn
                  attrBtn={{
                    color: "success",
                    size: "sm",
                    onClick: () => navigate("/product/newProduct"),
                    disabled: admin?.role === "ASSISTANT"
                  }}
                >
                  <i className="fa fa-plus-circle me-1" />
                  Registrar Producto
                </Btn>
              </div>
              <CardBody>
                <DataTable
                  data={data?.data?.products ?? []}
                  total={data?.data?.total ?? 0}
                  pagination={pagination}
                  setPagination={setPagination}
                  columns={columns}
                  progressPending={isLoading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
